module.exports = __webpack_public_path__ + "resource/img/close.d5b0a10f.svg";